export default "__VITE_ASSET__14312458__$_?v=2__"